import React from "react";
import { Link, useHistory } from "react-router-dom";
import { ReactComponent as ChevronLeft } from "@ugg/shared/assets/svg/chevron-left.svg";

const SettingsBackLink = (props) => {
  const history = useHistory();
  const { to, goBack } = props;

  const onClick = (e) => {
    if (goBack) {
      return history.goBack();
    } else {
      history.push(to);
    }
  };

  return (
    <div className="settings-back group cursor-pointer" onClick={onClick}>
      <ChevronLeft className="w-[8px] group-hover:[&>path]:fill-accent-blue-400" />
      <span className="group-hover:text-accent-blue-400">Back</span>
    </div>
  );
};

export default SettingsBackLink;
